export default __webpack_public_path__ + "static/21_18-2d3889dfe7fe3c427fc8705de5dc276a.png";